import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';

function googleMaps() {
  Vue.use(VueGoogleMaps, {
    load: {
      key: process.env.VUE_APP_GOOGLE_MAPS,
      libraries: 'places,visualization,drawing',
      v: '3.26'
    },
    installComponents: true
  });
}

export { googleMaps };
